// extracted by mini-css-extract-plugin
export default {"card":"AdminNewCard_card__anrbM","number":"AdminNewCard_number__ecjym","wrapperIcon":"AdminNewCard_wrapperIcon__Pz8Mx","icon":"AdminNewCard_icon__Qa3DJ"};